import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { routes } from '../routes';

const Sidebar = (props) => {
    return (
        <div className="navbar navbar-dark d-block bg-dark text-white position-fixed h-100 align-self-start w-sidebar p-0 pt-2 pb-4" id="sidebar">
            <button data-toggle="collapse" data-target=".sidebar-collapse" className="navbar-brand my-1 mr-3 float-right p-0 d-inline-block d-lg-none btn btn-link">
                <span className="h4 align-middle mb-0"><span className="lnr lnr-menu"></span></span>
            </button>
            <div className="nav flex-column flex-wrap pt-5 mt-3 text-uppercase" id="menu1">
                {
                  routes
                  .filter((rte,key) => {return rte.showInNav === true})
                  .map((rte,key) => {
                    if (!rte.children) {
                        var active = "";
                        if (props.match.path===rte.path) {
                            active = "active";
                        }
                        return (
                          <Link className={'nav-item nav-link ripple' + (rte.className||'') + ' ' + active} to={rte.path} key={key}>
                            <i className={rte.icon + ' mr-2'}></i> 
                            <span className='text-truncate align-middle'>{rte.name}</span>
                          </Link>
                        );
                    }
                    else {
                        // route with children
                        return (
                            <React.Fragment key={key}>
                                <button className="nav-link btn btn-link text-left py-2 text-uppercase" aria-expanded="false" data-toggle="collapse" data-target={'#submenu'+key}>
                                    <i className={rte.icon + ' mr-2'}></i>
                                    <span className='text-truncate align-middle'>{rte.name}</span>
                                </button>
                                <div className="collapse" id={'submenu'+key} data-parent="#menu1">
                                    <div className="nav pb-2 flex-column flex-wrap text-truncate">
                                    { rte.children.map((child,i) => {
                                        return (
                                            <Link className="nav-item nav-link" to={child.path} key={i}>
                                            { child.name }
                                            </Link>
                                        
                                        );
                                    }) }
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    }
                  })
                }
            </div>
        </div>
    );
};

export default withRouter(Sidebar);